import {
	RoleApplicationPermissionContext,
	RoleGeneralContextModel,
	RoleGeneralPermissionContext,
	RoleHardwarePermissionContext,
	RoleMemberContext,
	UserRole,
} from '../../../../../model/DeviceAdminModel';

export enum ContextActionTypes {
	SET_FORCE_RENDER_CONTEXT_MODEL = 'SET_FORCE_RENDER_CONTEXT_MODEL',
	SET_ROLES_CONTEXT_MODEL = 'SET_ROLES_CONTEXT_MODEL',
	SET_ROLE_PROPS_CONTEXT_MODEL = 'SET_ROLE_PROPS_CONTEXT_MODEL',
	SET_MEMBER_CONTEXT_MODEL = 'SET_ROLE_CONTEXT_MODEL',
	SET_APPLICATION_PERMISSION_CONTEXT_MODEL = 'SET_APPLICATION_PERMISSION_CONTEXT_MODEL',
	SET_GENERAL_PERMISSION_CONTEXT_MODEL = 'SET_GENERAL_PERMISSION_CONTEXT_MODEL',
	SET_SELECTED_GENERAL_PERMISSION_CONTEXT_MODEL = 'SET_SELECTED_GENERAL_PERMISSION_CONTEXT_MODEL',
	SET_HARDWARE_PERMISSION_CONTEXT_MODEL = 'SET_HARDWARE_PERMISSION_CONTEXT_MODEL',
	SET_CLEAR_IS_DIRTY_CONTEXT_MODEL = 'SET_CLEAR_IS_DIRTY_CONTEXT_MODEL',
}

export type setForceRenderContextModel = {
	type: ContextActionTypes.SET_FORCE_RENDER_CONTEXT_MODEL;
};

export type setRolesContextModel = {
	type: ContextActionTypes.SET_ROLES_CONTEXT_MODEL;
	payload: UserRole[];
};

export type setRolePropsContextModel = {
	type: ContextActionTypes.SET_ROLE_PROPS_CONTEXT_MODEL;
	payload: Partial<RoleGeneralContextModel>;
};

export type setRoleMemberContextModel = {
	type: ContextActionTypes.SET_MEMBER_CONTEXT_MODEL;
	payload: RoleMemberContext;
};

export type setApplicationPermissionContextModel = {
	type: ContextActionTypes.SET_APPLICATION_PERMISSION_CONTEXT_MODEL;
	payload: RoleApplicationPermissionContext;
};

export type setGeneralPermissionContextModel = {
	type: ContextActionTypes.SET_GENERAL_PERMISSION_CONTEXT_MODEL;
	payload: Partial<RoleGeneralPermissionContext>;
};

export type setSelectedGeneralPermissionContextModel = {
	type: ContextActionTypes.SET_SELECTED_GENERAL_PERMISSION_CONTEXT_MODEL;
	payload: number;
};

export type setHardwarePermissionContextModel = {
	type: ContextActionTypes.SET_HARDWARE_PERMISSION_CONTEXT_MODEL;
	payload: RoleHardwarePermissionContext;
};

export type setClearIsDirtyContextModel = {
	type: ContextActionTypes.SET_CLEAR_IS_DIRTY_CONTEXT_MODEL;
};

export type ActionContext =
	| setForceRenderContextModel
	| setRolesContextModel
	| setRolePropsContextModel
	| setRoleMemberContextModel
	| setApplicationPermissionContextModel
	| setGeneralPermissionContextModel
	| setSelectedGeneralPermissionContextModel
	| setHardwarePermissionContextModel
	| setClearIsDirtyContextModel;
